export default "__VITE_ASSET__5eca6e27__"